import gql from 'graphql-tag';

export default gql`
  query getUpcomingInvoice(
    $customer_id: ID
    $subscription_id: ID
  ) {
    getUpcomingInvoice(
      customer_id: $customer_id
      subscription_id: $subscription_id
    ) {
      id
      customer_id
      subscription_id
      collection_method
      amount_due
      amount_paid
      amount_remaining
      total
      paid
      lines {
        quantity
        id
        amount
        description
        quantity
        period {
          start
          end
        }
        plan {
          id
          active
          amount
          nickname
          usage_type
        }
      }
    }
  }
`;
